import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { CampaignStepUpdateInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-update-interface';
import { CampaignStepViewInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-view-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useUpdateCampaignStep = id => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put,
      badRequestHandler: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== id) {
    const baseFetcher = data => fetcher(`${CAMPAIGNS_API}/steps/${id}`, data);
    t1 = {
      fetcherUpdateCampaignStep: data_0 => baseFetcher(data_0)
    };
    $[1] = fetcher;
    $[2] = id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};